<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
             <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                 <p class="title"><v-icon left color="success">mdi-fish</v-icon>{{fish}}</p>

                <v-text-field
                outlined
                 v-model="weight"
                  @focus="weight=''"
                  label="Kilo(s)"
                   :rules="textRules"
                required
                ></v-text-field>
             </v-form>
             <v-divider/>
        </v-card-text>
        <v-card-actions>
            
                <v-btn color="default" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success" rounded  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    fish: {
         type: String,
        default: ""
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      weight: 0,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "OK"
         else 
            return "SAVE"
      }
  },
  watch: {
    show () {
      if(!this.show) {
          this.weight = 0
      }
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
        }
      },
    emitToParent (action) {
      action != 'close'?this.weight = this.weight.trim():this.weight=0
      this.$emit('DialogEvent', {action: action, weight: this.weight})
    }
  }
}
</script>
